<template>
  <f7-app
    :params="f7params">
    <f7-view
      main />
  </f7-app>
</template>

<script>
import routes from '@/routes'
export default {
  name: 'app',
  data () {
    return {
      f7ready: false,
      f7params: {
        theme: 'auto',
        routes,
        id: 'com.attestation.app'
      }
    }
  }
}
</script>

<style lang="scss">
// --f7-theme-color: #c8c864;
// --f7-theme-color-rgb: 200, 200, 100;
// --f7-theme-color-shade: #b5b252;
// --f7-theme-color-tint: #d6d370;
</style>
